import { sectionLabels } from "../section-labels";
/**
 * The "order ahead" / "order pickup" call to action.
 *
 * ## previewOnly: pickup routing is an open decision
 *
 * Whether a restaurant takes a pickup order through the invoice shape or back
 * through the existing order flow is **Open Decision 1** in
 * `docs/restaurant-context.md` §10 — explicitly the founder's to make, and
 * explicitly not one an implementation may settle by building one of them. No
 * endpoint accepts a pickup order today.
 *
 * The one ordering path that DOES exist is dine-in: a diner at a table scans
 * the QR code and sends a staff-approved request. That is a different surface
 * with its own route, and it needs no button here.
 *
 * So this ships `visible: false` and renders badged in the preview. A live
 * "ORDER PICKUP" button that submits nowhere is worse than no button: the
 * customer believes food is coming.
 */
export const restaurantOrderCtaSchema = {
    type: "restaurant-order-cta",
    name: sectionLabels["restaurant-order-cta"],
    description: {
        ar: "زر الطلب المسبق للاستلام. لسه مش شغّال — بيظهر في المعاينة بس.",
        en: "The order-ahead / pickup button. Not built yet — preview only.",
    },
    previewOnly: true,
    maxPerTemplate: 1,
    availableOnTemplates: ["home"],
    availableOnStoreKinds: ["RESTAURANT"],
    settings: [
        {
            id: "label",
            type: "text",
            i18n: true,
            label: { ar: "نص الزر", en: "Button label" },
            validate: { max: 32 },
        },
        {
            id: "note",
            type: "text",
            i18n: true,
            label: { ar: "سطر تحت الزر", en: "Supporting line" },
            helpText: {
                ar: "«جاهز في ١٢ دقيقة» مثلًا.",
                en: '"Ready in 12 minutes", for example.',
            },
            validate: { max: 60 },
        },
    ],
};
//# sourceMappingURL=restaurant-order-cta.js.map